import { createFileRoute } from "@tanstack/react-router";
import Soluciones from "../pages/Soluciones";

export const Route = createFileRoute("/soluciones")({
  head: () => ({
    meta: [
      {
        title: "Producto — Siete herramientas, un sistema | CreceLocal",
      },
      {
        name: "description",
        content:
          "Sitio web, ficha de Google, sistema de reseñas, campañas de WhatsApp, inbox unificado, SEO local, seguimiento automático y agente IA. Seis vienen en el plan; el Agente IA se suma cuando el volumen lo justifica.",
      },
      {
        property: "og:title",
        content: "Producto — Siete herramientas, un sistema | CreceLocal",
      },
      {
        property: "og:description",
        content:
          "Sitio web, ficha de Google, sistema de reseñas, campañas de WhatsApp, inbox unificado, SEO local, seguimiento automático y agente IA. Seis vienen en el plan; el Agente IA se suma cuando el volumen lo justifica.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Soluciones,
});
